module.exports = __webpack_public_path__ + "static/media/stm-21st-mobile-822x186-@2x.b5f202b5.png";